import { ANNEXURE_PARTS } from "../actions/actionsTypes";
import { IGlobal } from "../models/global.interface";
import { IActionBase } from "../models/root.interface";

const initialState = {
  getAnnexureListData: null,
  getAllAnnexureListData: null,
  addNewAnnxurePart: null,
  editAnnexurePartDetails: null,
  importAnnexurePart: null,
};

function annexureListReducer(state: any = initialState, action: IActionBase): IGlobal {
  switch (action.type) {
    case ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_FETCHING:
      return {
        ...state,
        getAnnexureListData: { loading: true, data: null, err: null },
        importAnnexurePart: null
      };
    case ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_SUCCESS:
      return {
        ...state,
        getAnnexureListData: {
          loading: false,
          data: action.payload.data,
          err: null
        },
        importAnnexurePart: null
      };
    case ANNEXURE_PARTS.GET_ANNEXURE_PARTS_LIST_ERROR:
      return {
        ...state,
        getAnnexureListData: { loading: false, data: null, err: action.payload.error }
      };
    case ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_FETCHING:
      return {
        ...state,
        getAllAnnexureListData: { loading: true, data: null, err: null },
        importAnnexurePart: null
      };
    case ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_SUCCESS:
      return {
        ...state,
        getAllAnnexureListData: {
          loading: false,
          data: action.payload.data,
          err: null
        },
        importAnnexurePart: null
      };
    case ANNEXURE_PARTS.GET_ALL_ANNEXURE_PARTS_LIST_ERROR:
      return {
        ...state,
        getAllAnnexureListData: { loading: false, data: null, err: action.payload.error }
      };
    case ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_FETCHING:
      return {
        ...state,
        addNewAnnxurePart: { loading: true, data: null, err: null }
      };
    case ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_SUCCESS:
      return {
        ...state,
        addNewAnnxurePart: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case ANNEXURE_PARTS.ADD_ANNEXURE_PARTS_ERROR:
      return {
        ...state,
        addNewAnnxurePart: { loading: false, data: null, err: action.payload.error }
      };

    case ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_FETCHING:
      return {
        ...state,
        editAnnexurePartDetails: { loading: true, data: null, err: null }
      };
    case ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_SUCCESS:
      return {
        ...state,
        editAnnexurePartDetails: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case ANNEXURE_PARTS.EDIT_ANNEXURE_PARTS_ERROR:
      return {
        ...state,
        editAnnexurePartDetails: { loading: false, data: null, err: action.payload.error }
      };

    case ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_FETCHING:
      return {
        ...state,
        importAnnexurePart: { loading: true, data: null, err: null }
      };
    case ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_SUCCESS:
      return {
        ...state,
        importAnnexurePart: {
          loading: false,
          data: action.payload.data,
          err: null
        }
      };
    case ANNEXURE_PARTS.IMPORT_ANNEXURE_PARTS_ERROR:
      return {
        ...state,
        importAnnexurePart: { loading: false, data: null, err: action.payload.error }
      };

    default:
      return state;
  }
};

export default annexureListReducer;